import React, { useEffect, useContext, useRef } from "react";
import "ui/UI.css";
import GlobalContext from "contexts/context";
import DatabaseContext from "data/contextDatabase";
import { Link } from "react-router-dom";

import UITopicList from "ui/UITopicList";
import UIPersonaManager from "ui/UIPersonaManager";
import UIMap from "ui/UIMap";
import UISwitch from "ui/UISwitch";
import UISearch from "ui/UISearch";
import UISearchTopic from "ui/UISearchTopic";

import { timeoutGet, timeoutPost } from "hooks/http";
import { randomNumber, randomString, isMobileTablet } from "hooks/helper";
import { useLiveParameters } from "hooks/dbHooks";
import { useLivePersonas } from "hooks/dbHooks";

import LocationContext from "geospatial/contextLocation";

const UILogin = (props) => {
  const { globalState, globalDispatch } = useContext(GlobalContext);
  const { locationState, locationDispatch } = useContext(LocationContext);
  const { databaseState, databaseDispatch } = useContext(DatabaseContext);
  const livePersonas = useLivePersonas(
    databaseState.dbMaster,
    globalState.muid
  );
  const liveParameters = useLiveParameters(
    databaseState.dbMaster,
    globalState.muid
  );

  const urlPersona =
    "https://2avoul47dg.execute-api.eu-central-1.amazonaws.com/prod";

  useEffect(() => {
    globalState.persona && console.log("active persona", globalState.persona);
    return () => {};
  }, [globalState.persona]);

  useEffect(() => {
    let lp = liveParameters.filter((i) => {
      return (
        i.muid === globalState.muid &&
        i.parameter === "validation" &&
        i.value === "required"
      );
    });
    console.log("liveParameters validation: ", liveParameters);
    if (lp.length === 0) {
      document.getElementById("otp_button").style.display = "none";
    } else {
      document.getElementById("otp_button").style.display = "block";
    }
    return () => {};
  }, [globalState.muid, liveParameters]);

  const createRandomCredentials = async () => {
    const response = await timeoutGet(urlPersona, {
      type: "randomname",
      msgid: randomString(8),
    });
    const randomPwd = randomNumber(5);
    return { uid: response.result, pwd: randomPwd };
  };

  const createPersona = async (uid, pwd, persona, tag) => {
    const response = await timeoutPost(urlPersona, {
      type: "addpersona",
      uid: uid,
      pwd: pwd,
      persona: persona,
      tag: tag,
      msgid: randomString(8),
    });
    console.log("createPersona: ", response);
    // returns {msgid, result: "personaadded", persona, tag}
    return response;
  };

  const timestamp = () => {
    let d = new Date();
    let ts_sender =
      d.getFullYear() +
      "-" +
      ("0" + (d.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + d.getDate()).slice(-2) +
      " " +
      ("0" + d.getHours()).slice(-2) +
      ":" +
      ("0" + d.getMinutes()).slice(-2) +
      ":" +
      ("0" + d.getSeconds()).slice(-2);
    return ts_sender;
  };

  const onRequestOTP = (identifier) => {
    let j = {
      type: "w.user.otp.request",
      muid: globalState.muid ? globalState.muid : "undefined",
      identifier: identifier,
      version: globalState.version,
      ts_sender: timestamp(),
      smid: randomString(8),
    };
    databaseState.dbMaster &&
      databaseDispatch({
        type: "UPSERT_REC",
        values: {
          jmessage: j,
          db: databaseState.dbMaster,
          collection: "send",
          table: "confirm_smid",
          rowid: j.smid,
          doc: j,
        },
      });
  };

  const onSubmitOTP = (identifier, otp) => {
    document.getElementById("otp_modal").style.display = "none";
    let j = {
      type: "w.user.otp.response",
      muid: globalState.muid ? globalState.muid : "undefined",
      identifier: identifier,
      otp: otp,
      version: globalState.version,
      ts_sender: timestamp(),
      smid: randomString(8),
    };
    databaseState.dbMaster &&
      databaseDispatch({
        type: "UPSERT_REC",
        values: {
          jmessage: j,
          db: databaseState.dbMaster,
          collection: "send",
          table: "confirm_smid",
          rowid: j.smid,
          doc: j,
        },
      });
  };

  const onSubmitCredentials = (username, password) => {
    console.log("UILogin onSubmitCredentials ", username, password);
    document.getElementById("login_modal").style.display = "none";
    databaseDispatch({
      type: "ADD_RECORD_ID",
      values: {
        db: databaseState.dbUser,
        doc: {
          _id: "client",
          cid: randomString(10),
        },
      },
    });
    databaseDispatch({
      type: "UPSERT_REC_ID",
      values: {
        db: databaseState.dbUser,
        doc: {
          _id: "user",
          uid: username,
          password: password,
        },
      },
    });
  };

  const onValidateUser = () => {
    document.getElementById("otp_modal").style.display = "block";
  };

  const onAutoUser = async () => {
    const user = await createRandomCredentials();
    console.log("onCreateUser: ", user);
    document.getElementById("uid_auto").value = user.uid;
    document.getElementById("password_auto").value = user.pwd;
    document.getElementById("auto_user_modal").style.display = "block";

    // const url = urlPersona;
    // const data = {
    //   type: "register",
    //   uid: user.uid,
    //   pwd: user.pwd,
    //   msgid: randomString(8),
    // };
    // const createUserResult = await timeoutPost(url, data);
    // if (createUserResult.result === "failed") {
    //   alert("User creation error: " + createUserResult.reason);
    // } else {
    //   const persona = await createPersona(
    //     user.uid,
    //     user.pwd,
    //     user.uid,
    //     "no tag"
    //   );
    //   console.log("oncreatePersona: ", persona);
    //   globalDispatch({
    //     type: "LOGIN",
    //     values: { uid: user.uid, password: user.pwd, muid: undefined },
    //   });
    // }
  };

  const onCreateUser = async (username, password) => {
    console.log("UILogin onCreateUser ", username, password);
    document.getElementById("auto_user_modal").style.display = "none";
    document.getElementById("create_user_modal").style.display = "none";
    const url = urlPersona;
    const data = {
      type: "register",
      uid: username,
      pwd: password,
      msgid: randomString(8),
    };
    const createUserResult = await timeoutPost(url, data);
    if (createUserResult.result === "failed") {
      switch (createUserResult.reason) {
        case "uidexists":
          alert("That user already exists, please try again");
          break;
        default: {
          alert("User creation error: " + createUserResult.reason);
          break;
        }
      }
    } else {
      const persona = await createPersona(
        username,
        password,
        username,
        "no tag"
      );
      console.log("oncreatePersona: ", persona);
      databaseDispatch({
        type: "ADD_RECORD_ID",
        values: {
          db: databaseState.dbUser,
          doc: {
            _id: "client",
            cid: randomString(10),
          },
        },
      });
      databaseDispatch({
        type: "UPSERT_REC_ID",
        values: {
          db: databaseState.dbUser,
          doc: {
            _id: "user",
            uid: username,
            password: password,
          },
        },
      });
    }
  };

  let uid = document.getElementById("uid_input")
    ? document.getElementById("uid_input").value
    : undefined;
  let password = document.getElementById("password_input")
    ? document.getElementById("password_input").value
    : undefined;
  let otp = undefined;
  let identifier = undefined;

  let showShare = (title, link) => {
    console.log("SHARING: ", title, link);
    document.getElementById("share_modal").style.display = "block";
    document.getElementById("share_modal_link_title").innerHTML = title;
    document.getElementById("share_modal_link").innerHTML = link;
    let elSMS = document.getElementById("hrefLinkSMS");
    elSMS &&
      (elSMS.href =
        "sms:?body=Try this cool chat web app...%0D%0A%0D%0A" +
        encodeURIComponent(link) +
        "%0D%0A%0D%0A");
    document.getElementById("hrefLinkEmail").href =
      "mailto:?subject=enabled.WORLD PWA&body=Try this cool chat web app...%0D%0A%0D%0A" +
      encodeURIComponent(link) +
      "%0D%0A%0D%0A";
  };

  let modalShare = (
    <div id="share_modal" className="UI-login-modal">
      <div className="UI-login-modal-content animate">
        <div className="UI-imgcontainer">
          <span
            onClick={() =>
              (document.getElementById("share_modal").style.display = "none")
            }
            className="UI-modal-close"
            title="Close Modal"
          >
            &times;
          </span>
        </div>

        <div className="UI-login-container">
          <h4 style={{ color: "#555", textDecoration: "none" }}>
            Share a link to
          </h4>
          <h2
            style={{
              color: "#555",
              textDecoration: "none",
              wordWrap: "break-word",
            }}
            id="share_modal_link_title"
          >
            {" "}
          </h2>
          <h4
            style={{
              color: "#555",
              textDecoration: "none",
              wordWrap: "break-word",
            }}
            id="share_modal_link"
          >
            {" "}
          </h4>
          {isMobileTablet() && (
            <a id="hrefLinkSMS" href="https://world.reaches.me">
              Share via SMS
            </a>
          )}
          <br></br>
          {true && (
            <a id="hrefLinkEmail" href="https://world.reaches.me">
              Share via email
            </a>
          )}
        </div>
      </div>
    </div>
  );

  let modalOTP = (
    <div id="otp_modal" className="UI-login-modal">
      <div className="UI-login-modal-content animate">
        <div className="UI-login-container">
          <label>
            <b>Mobile number for OTP validation</b>
          </label>
          <input
            className="UI-input"
            type="uid"
            placeholder="Enter mobile digits"
            name="identifier"
            required
            id="identifier_input"
            onChange={() => {
              identifier = document.getElementById("identifier_input").value;
            }}
          />

          <button
            className="UI-button"
            type="login"
            onClick={() => {
              onRequestOTP(document.getElementById("identifier_input").value);
            }}
          >
            Request OTP digits
          </button>
        </div>

        <div className="UI-login-container">
          <label>
            <b>OTP from SMS response</b>
          </label>
          <input
            className="UI-input"
            type="uid"
            placeholder="Enter OTP digits"
            name="otp"
            required
            id="otp_input"
            onChange={() => {
              otp = document.getElementById("otp_input").value;
            }}
          />

          <button
            className="UI-button"
            type="login"
            onClick={() => {
              onSubmitOTP(
                document.getElementById("identifier_input").value,
                document.getElementById("otp_input").value
              );
            }}
          >
            Submit OTP digits
          </button>
        </div>
      </div>
    </div>
  );

  let modalLogin = (
    <div id="login_modal" className="UI-login-modal">
      <div className="UI-login-modal-content animate">
        <div className="UI-imgcontainer">
          <span
            onClick={() =>
              (document.getElementById("login_modal").style.display = "none")
            }
            className="UI-modal-close"
            title="Close Modal"
          >
            &times;
          </span>
          {/* <img src="duck.jpg" alt="Avatar" className="UI-avatar" /> */}
        </div>

        <div className="UI-login-container">
          <h2 style={{ color: "#555", textDecoration: "none" }}>
            <b>Login</b>
          </h2>
          <h4 style={{ color: "#555", textDecoration: "none" }}>
            using your existing name and password
          </h4>
          <h6 style={{ color: "#555", textDecoration: "none" }}>
            Note: logging in on multiple devices with the same user is not yet
            supported and will cause temporary errors
          </h6>
          <label>
            <b>Username</b>
          </label>
          <input
            className="UI-input"
            type="uid"
            placeholder="Enter Username"
            name="uid"
            required
            id="uid_input"
            onChange={() => {
              uid = document.getElementById("uid_input").value;
            }}
          />

          <label>
            <b>Password</b>
          </label>
          <input
            className="UI-input"
            type="password"
            placeholder="Enter Password"
            name="password"
            required
            id="password_input"
            onChange={() => {
              password = document.getElementById("password_input").value;
            }}
          />

          <button
            className="UI-button"
            type="login"
            onClick={() => {
              onSubmitCredentials(uid, password);
            }}
          >
            Login
          </button>
        </div>
      </div>
    </div>
  );

  let modalCreateUser = (
    <div id="create_user_modal" className="UI-login-modal">
      <div className="UI-login-modal-content animate">
        <div className="UI-imgcontainer">
          <span
            onClick={() =>
              (document.getElementById("create_user_modal").style.display =
                "none")
            }
            className="UI-modal-close"
            title="Close Modal"
          >
            &times;
          </span>
          {/* <img src="world_logo.png" alt="Avatar" className="UI-avatar" /> */}
        </div>

        <div className="UI-login-container">
          <label>
            <b>Username</b>
          </label>
          <input
            className="UI-input"
            type="uid"
            placeholder="Choose a Username"
            name="uid"
            required
            id="uid_new"
            onChange={() => {
              uid = document.getElementById("uid_new").value;
            }}
          />

          <label>
            <b>Password</b>
          </label>
          <input
            className="UI-input"
            type="password"
            placeholder="Choose a Password"
            name="password"
            required
            id="password_new"
            onChange={() => {
              password = document.getElementById("password_new").value;
            }}
          />

          <button
            className="UI-button"
            type="login"
            onClick={() => {
              onCreateUser(uid, password);
            }}
          >
            Create user and log in
          </button>
        </div>
      </div>
    </div>
  );

  let modalAutoUser = (
    <div id="auto_user_modal" className="UI-login-modal">
      <div className="UI-login-modal-content animate">
        <div className="UI-imgcontainer">
          <span
            onClick={() =>
              (document.getElementById("auto_user_modal").style.display =
                "none")
            }
            className="UI-modal-close"
            title="Close Modal"
          >
            &times;
          </span>
          {/* <img src="world_logo.png" alt="Avatar" className="UI-avatar" /> */}
        </div>

        <div className="UI-login-container">
          <h2 style={{ color: "#555", textDecoration: "none" }}>
            <b>Create a new user</b>
          </h2>
          <h4 style={{ color: "#555", textDecoration: "none" }}>
            You can use these credentials <br />
            or <br />
            ENTER ANY USER NAME AND PASSWORD{" "}
          </h4>

          <label style={{ color: "#555", textDecoration: "none" }}>
            <b>Username</b>
          </label>
          <input
            className="UI-input"
            type="uid"
            placeholder="Choose a Username"
            name="uid"
            required
            id="uid_auto"
            onChange={() => {
              uid = document.getElementById("uid_auto").value;
            }}
          />

          <label style={{ color: "#555", textDecoration: "none" }}>
            <b>Password</b>
          </label>
          <input
            className="UI-input"
            type="uid"
            placeholder="Choose a Password"
            name="password"
            required
            id="password_auto"
            onChange={() => {
              password = document.getElementById("password_auto").value;
            }}
          />

          <button
            className="UI-button"
            type="login"
            onClick={() => {
              onCreateUser(
                document.getElementById("uid_auto").value,
                document.getElementById("password_auto").value
              );
            }}
          >
            Create this user
          </button>
        </div>
      </div>
    </div>
  );

  let modalSearch = (
    <div id="search_modal" className="UI-login-modal">
      <div className="UI-login-modal-content animate">
        <div className="UI-imgcontainer">
          <span
            onClick={() =>
              (document.getElementById("search_modal").style.display = "none")
            }
            className="UI-modal-close"
            title="Close Modal"
          >
            &times;
          </span>
        </div>

        <UISearch
          muid={globalState.muid}
          mpersona={livePersonas ? livePersonas[0]?.mpersona : undefined}
          persona={livePersonas ? livePersonas[0]?.persona : undefined}
        />
      </div>
    </div>
  );

  let modalSearchTopic = (
    <div id="search_topic_modal" className="UI-login-modal">
      <div className="UI-login-modal-content animate">
        <div className="UI-imgcontainer">
          <span
            onClick={() =>
              (document.getElementById("search_topic_modal").style.display =
                "none")
            }
            className="UI-modal-close"
            title="Close Modal"
          >
            &times;
          </span>
        </div>
        <UISearchTopic
          muid={globalState.muid}
          mpersona={livePersonas ? livePersonas[0]?.mpersona : undefined}
          persona={livePersonas ? livePersonas[0]?.persona : undefined}
        />
      </div>
    </div>
  );

  let startTime, endTime, longpress, timer;

  const onLongPress = (choice) => {
    alert("Long pressed " + choice);
    // let el = document.getElementById("lp_"+choice.id);
    // if (el) {el.style.display = el.style.display == "inline" ? "none" : "inline"};
  };

  let content = (
    <div className="UI">
      <div className="UI-frame">
        {modalLogin}
        {modalCreateUser}
        {modalAutoUser}
        {modalOTP}
        {modalSearch}
        {modalSearchTopic}
        {modalShare}

        <UIMap db={databaseState.dbMaster} />

        <div className="UI-switch-group">
          <UISwitch
            blurb={
              locationState.useLocation === "true"
                ? "Using my location, tap to turn off"
                : "Location is not being used, tap to turn on"
            }
            idTag="permission_requests"
            onChange={() => {
              var cb = document.getElementById("permission_requests");
              //              cb.checked && Notification.requestPermission();
              console.log("Notification: " + Notification.permission);
              console.log(
                "Notification option changed: " +
                  (cb.checked ? "true" : "false")
              );
              locationDispatch({
                type: "SET_USE_LOCATION",
                values: {
                  useLocation: cb.checked ? "true" : "false",
                },
              });
            }}
            checked={locationState.useLocation === "true"}
          />
        </div>

        <h4>
          {globalState.authenticated ? "Logged in as " : "Logging in as "}
          {globalState.uid ? globalState.uid : " - "}
        </h4>

        <div className="UI-login-frame">
          <div
            className={
              globalState.uid
                ? "tooltip"
                : localStorage.getItem("beenUsed")
                ? "tooltip tooltipinit"
                : "tooltip"
            }
          >
            <span
              className={
                globalState.uid
                  ? "tooltiptext"
                  : localStorage.getItem("beenUsed")
                  ? "tooltiptext tooltipinit"
                  : "tooltiptext"
              }
            >
              Existing user login
            </span>
            <button
              id="login_button"
              className="UI-button-icon"
              type="login"
              onClick={() =>
                // (longpress) ? {} :
                (document.getElementById("login_modal").style.display = "block")
              }
            ></button>
          </div>
          {/* <button
            onClick={() =>
              (document.getElementById("create_user_modal").style.display =
                "block")
            }
            className="UI-button"
            type="login"
          >
            Create a new user
          </button> */}

          <div
            className={
              localStorage.getItem("beenUsed")
                ? "tooltip"
                : "tooltip tooltipinit"
            }
          >
            <span
              className={
                localStorage.getItem("beenUsed")
                  ? "tooltiptext"
                  : "tooltiptext tooltipinit"
              }
            >
              Create new user
            </span>
            <button
              id="new_user_button"
              className="UI-button-icon"
              type="new_user"
              onClick={() => onAutoUser()}
            ></button>
          </div>

          <button
            onClick={() => onValidateUser()}
            className="UI-button"
            type="login"
            id="otp_button"
          >
            Validate User
          </button>

          <div className="tooltip">
            <span className="tooltiptext">Search for persona</span>
            <button
              id="persona_search_button"
              className="UI-button-icon"
              type="persona_search"
              onClick={() =>
                (document.getElementById("search_modal").style.display =
                  "block")
              }
            ></button>
          </div>

          <div className="tooltip">
            <span className="tooltiptext">Search for topic</span>
            <button
              id="topic_search_button"
              className="UI-button-icon"
              type="topic_search"
              onClick={() =>
                (document.getElementById("search_topic_modal").style.display =
                  "block")
              }
            ></button>
          </div>

          <div className="tooltip">
            <span className="tooltiptext">Share invitation</span>
            <button
              id="dialog_share_button"
              className="UI-button-icon"
              type="my_dialog"
              onClick={() => {
                let link = livePersonas
                  ? "https://world.reaches.me/dialog/" +
                    livePersonas[0]?.mpersona +
                    "/" +
                    livePersonas[0]?.persona
                  : "https://world.reaches.me/";
                showShare(
                  livePersonas ? livePersonas[0]?.persona : "WORLD",
                  link
                );
              }}
            ></button>
          </div>
        </div>
        <UIPersonaManager />
        <UITopicList db={databaseState.dbMaster} share={showShare} />
      </div>
    </div>
  );

  // When the user clicks anywhere outside of the modal, close it
  var modal = document.getElementById("login_modal");
  var create_user_modal = document.getElementById("create_user_modal");
  var auto_user_modal = document.getElementById("auto_user_modal");
  var otp_modal = document.getElementById("otp_modal");
  var search_modal = document.getElementById("search_modal");
  var search_topic_modal = document.getElementById("search_topic_modal");
  var share_modal = document.getElementById("share_modal");
  window.onclick = function (event) {
    switch (event.target) {
      case modal:
        modal.style.display = "none";
        break;
      case create_user_modal:
        create_user_modal.style.display = "none";
        break;
      case auto_user_modal:
        auto_user_modal.style.display = "none";
        break;
      case otp_modal:
        otp_modal.style.display = "none";
        break;
      case search_modal:
        search_modal.style.display = "none";
        break;
      case search_topic_modal:
        search_topic_modal.style.display = "none";
        break;
      case share_modal:
        share_modal.style.display = "none";
        break;
      default: {
        break;
      }
    }
  };

  return content;
};

// memo acts like shouldComponentUpdate ... can use without the function, or with a function that returns false if it SHOULD rerender
export default React.memo(UILogin, (prevProps, nextProps) => {
  return prevProps === nextProps;
});
